import { Pipe, PipeTransform } from '@angular/core';
import { DateUtils } from '../date-utils';

@Pipe({ name: 'formatDateTrigramme' })
export class FormatDateTrigramPipe implements PipeTransform {
  transform(dateString: string | null, showYear: boolean = true): string {
    if (dateString) {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = DateUtils.getMonthAsShortString(date.getMonth());
      const year = date.getFullYear().toString().slice(-2);

      return showYear ? `${day} ${month} ${year}` : `${day} ${month}`;
    } else {
      return '';
    }
  }
}
